<div class="card-campanha" (click)="onRowClick(campanha)">
    <div class="code">
        <span>Código</span>
        <h4>{{ codigo }}</h4>
    </div>

    <article class="tittle">
        <span>Título</span>
        <h4>{{ titulo }}</h4>
    </article>

    <article class="tittle">
        <span>Sector</span>
        <h4>{{ Sector }}</h4>
    </article>

    <article>
        <span>Objectivo</span>
        <h4>{{ Objectivo |money }}</h4>
    </article>

    <article>
        <span>Arrecadado</span>
        <h4>{{ Arrecadado | money }}</h4>
    </article>

    <article>
        <span>Data de Criação</span>
        <h4>{{ DataCriacao }}</h4>
    </article>

    <article>
        <button pButton icon="pi pi-bell" [rounded]="true" severity="warn" [outlined]="true"
            *ngIf="temProrrogarAtiva(campanha)" style="cursor: pointer;" (click)="abrirModal(campanha, $event)">
        </button>
    </article>

    <div class="item-icon">
        <span>Estado</span>
        <p-tag [severity]="getSeverity(estado)" [value]="estado"></p-tag>
    </div>

    <div class="flex justify-center items-center ml-4" (click)="$event.stopPropagation()">
        <p-menu #menuRef [model]="getMenuActions(campanha)" [popup]="true" appendTo="body" [autoZIndex]="true"
            [baseZIndex]="10000">
        </p-menu>

        <p-button icon="pi pi-ellipsis-v" severity="secondary" (click)="openMenu($event, menuRef)">
        </p-button>
    </div>

</div>

<p-dialog header="Solicitação de Prorrogação" [(visible)]="displayModal" modal="true" [closable]="true" [style]="{'width': '580px'}"
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    <div *ngIf="prorrogarSelecionada" class="p-fluid grid list_soli">
        <div class="col-12 field">
            <span>Motivo</span>
            <p>{{ prorrogarSelecionada.motivo }}</p>
        </div>
        <div class="col-12 field">
            <span>Dias</span>
            <p>{{ prorrogarSelecionada.dias }}</p>
        </div>
        <div class="col-12 field">
            <span>Data da prorrogação</span>
            <p>{{ prorrogarSelecionada.dataCriacaoFormatada }}</p>
        </div>

        <div class="col-12 mt-3 flex aling-items-center justify-content-between">
            <button pButton label="Cancelar" (click)="displayModal = false" severity="secondary"></button>
            <button type="button" class="btn_one" (click)="AprovarProrrogacao(campanha)">
                {{loading ? 'Prorrogando' : 'Prorrogar'}}
            </button>
        </div>
    </div>
</p-dialog>